<template>
  <el-select
    v-if="multiple"
    :size="size"
    v-model="names"
    :disabled="disabled"
    ref="select"
    @change="change"
    :filterable="filterable"
    :filter-method="filterMethod"
    :placeholder="placeholder"
    @visible-change="handleVisibleChange"
  >
    <el-option :size="size" :value="ids" style="height: auto;padding: 0">
      <el-tree
        class="font-weight-nomarl"
        :data="data"
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
         @check="handleCheckChange1"
        show-checkbox
        :check-strictly="checkStrictly"

      ></el-tree>
    </el-option>
  </el-select>
  <el-select
    v-else
    :size="size"
    v-model="name"
    :disabled="disabled"
    ref="select"
    @change="change"
    clearable
    :filterable="filterable"
    :filter-method="filterMethod"
    :placeholder="placeholder"
  >
    <el-option :size="size" :value="id" style="height: auto;padding: 0">
      <el-tree
        class="font-weight-nomarl"
        :data="data"
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
        @node-click="handleCheckChange"
      ></el-tree>
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: "SelectTree",
  data() {
    return {
      id: "",
      name: "",
      ids: "",
      names: "",
    };
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultProps: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    defaultValue: {
      type: String,
      default() {
        return "";
      },
    },
    size: {
      type: String,
      default() {
        return "medium";
      },
    },
    placeholder: {
      type: String,
      default() {
        return "请选择";
      },
    },
    filterMethod: {
      type: Function,
      defult() {
        return () => {};
      },
    },
    filterable: {
      type: Boolean,
      defult() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      defult() {
        return false;
      },
    },
    checkStrictly: {
      type: Boolean,
      defult() {
        return false;
      },
    },
  },
  watch: {
    defaultValue(newVal, oldVal) {
      if (this.multiple) {
        this.names = newVal;
      } else {
        this.name = newVal;
      }
    },
  },
  created() {
    this.name = this.defaultValue;
    this.names = this.defaultValue;
  },
  methods: {
    handleCheckChange() {
      let node = this.$refs.tree.getCurrentNode();
      this.id = node.id;
      this.name = node.name;
      this.$refs.select.blur();
      this.$emit("handleCheckChange", node);
    },
    handleVisibleChange(e) {
      console.log(e);
      
      if (!e) {
        this.$emit("handleCheckChange", this.$refs.tree.getCheckedNodes());
      }
    },
    handleCheckChange1(val,row,){
      
      this.$emit("handleCheckChange", row.checkedNodes);
    },
    change(val) {
      
      this.$emit("handleCheckChange", null);
    },
    setIds(ids) {
      this.$refs.tree.setCheckedKeys(ids.split(";"));
    },
  },
};
</script>
<style>
.font-weight-nomarl {
  font-weight: normal !important;
}
</style>
